var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.5907 12.0343C19.5391 12.0461 19.4858 12.0208 19.4597 11.973C19.4337 11.9252 19.4413 11.8651 19.4782 11.8258C20.9941 10.2027 29.09 0.926025 29.09 0.926025C29.09 0.926025 33.3574 8.53745 34.2564 11.3239C34.2624 11.343 34.2586 11.3643 34.2461 11.3795C34.2336 11.3953 34.214 11.4026 34.1944 11.3998C29.2597 10.6214 24.5309 10.9277 19.5907 12.0343Z",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.0739 19.691L39.2982 29.6822C34.3497 34.5684 24.9344 36.7044 19.0923 32.5776L15.1912 36.4297C19.2722 36.4068 25.9998 42.8994 25.9998 42.8994C25.9998 42.8994 18.4046 48.1483 15.4485 48.1483C12.4924 48.1483 9.52381 46.7774 7.41884 44.1036L3.82195 47.6552C3.15913 48.3097 2.08572 48.3097 1.4229 47.6552C0.760076 47.0007 0.760076 45.9408 1.4229 45.2864L16.691 30.2105C13.6981 26.0803 13.9571 20.0482 16.2386 15.1569C16.303 15.0184 16.4269 14.9151 16.5756 14.8743C22.9561 13.1398 29.0279 12.2603 35.8325 13.6475C40.1183 14.5203 49.0739 19.691 49.0739 19.691Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.5044 11.7951C36.0302 10.0176 35.4099 8.27663 34.6597 6.57558C36.5243 6.19266 44.4444 4.62964 44.4444 4.62964C44.4444 4.62964 42.042 11.7978 41.6666 13.6906C39.9786 12.9155 38.2563 12.2791 36.5044 11.7951Z",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRose);
export default __webpack_public_path__ + "static/media/rose.444f979820fd2f08aa2bd78ad9ccf991.svg";
export { ForwardRef as ReactComponent };